import { render, staticRenderFns } from "./myWarehouse.vue?vue&type=template&id=475a10c9&scoped=true"
import script from "./myWarehouse.vue?vue&type=script&lang=js"
export * from "./myWarehouse.vue?vue&type=script&lang=js"
import style0 from "./myWarehouse.vue?vue&type=style&index=0&id=475a10c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a10c9",
  null
  
)

export default component.exports